import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';

import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  create_order_used_record_by_card,
  delete_card_record,
  get_project_by_id,
  active_card_record,
  send_receipt,
  query_person_to_costom_list,
  direct_delete_set_record,
  direct_delete_card_record,
  get_card_by_id,
  trans_card_record,
  delete_appointment,
} from '@/api/mjstore-model';

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
import modalBox from '@/components/form-modal/modal-tools';
import { message, notification, Modal } from 'ant-design-vue';

export const event_obj = mitt();
import { createVNode, reactive, ref } from 'vue';
import moment from 'moment';
import bus from '@/utils/bus';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
const event_bus = bus;

export const btn_list = [
  {
    name: '激活',
    clazz: 'primary',
    is_show: (record: any) => {
      return (record.used_status == 0 || record.used_status == 1) && record.card_type == 11;
    },
    cb: (record: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '激活',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'datepicker',
              name: 'date',
              label: '激活时间',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              showTime: false,
              placeholder: '请选择激活时间',
            },
          ],
          rules: {
            date: [{ required: true, message: '请选择激活时间' }],
          },

          model: {
            org_id: current_org?.id,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            active_card_record({
              org_id: current_org?.id,
              card_record_id: record.id,
              date: payload.date,
            })
              .then(() => {
                if (moment(payload.date) > moment()) {
                  message.success('操作成功');
                } else {
                  message.success('激活成功');
                }
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '耗卡',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.card_type != 31 && (record.used_status == 2 || record.card_type == 1);
    },
    cb: (record: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '耗卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [7, 10],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
            },
            {
              type: 'input',
              name: 'card__name',
              label: '卡',
              disabled: true,
            },
            {
              type: 'number',
              name: 'card_num',
              label: '消耗卡次',
              min:
                record.now_num == 0 && record.card_type == 11 && moment(record.end_date) > moment()
                  ? 0
                  : 1,
              disabled:
                record.now_num == 0 && record.card_type == 11 && moment(record.end_date) > moment()
                  ? true
                  : false,
              placeholder: '请输入消耗卡次',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '项目单价',
              disabled: true,
            },
            {
              type: 'input',
              name: 'price',
              label: '项目金额',
              disabled: true,
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
              mode: 'default',
              allowClear: true,
            },
            {
              type: 'remoteselect',
              name: 'project_id',
              label: '项目名称（单）',
              disabled: false,
              placeholder: '请选择服务项目',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-project2',
            },
            {
              type: 'number',
              name: 'num',
              label: '项目次数',
              disabled: false,
              min:1,
              step:1,
              formatter:(value:any)=>{
                return Math.trunc(value);
              },
            },
            {
              type: 'number',
              name: '_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'project_price',
              label: '项目金额',
              disabled: true,
            },
            {
              type: 'number',
              name: 'diff_price',
              label: '换单价差',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '耗卡日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              showTime: true,
              placeholder: '请选择耗卡日期',
            },
            {
              type: 'textarea',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            project_id: [{ required: true, message: '请选项目名称' }],
            diff_price: [{ required: true, message: '请填写换单差价' }],
            customer_id: [{ required: true, message: '请选择会员姓名' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            card_num: [{ required: true, message: '请填写消耗卡次' }],
            num: [{ required: true, message: '请填写项目次数' }],
            date: [
              { required: true, message: '请填写耗卡时间' },
              {
                validator: async (rule: RuleObject, value: string) => {
                  if (moment(value) > moment()) {
                    return Promise.reject('不能选择大于当前日期的时间');
                  } else {
                    return Promise.resolve();
                  }
                },
                trigger: 'change',
              },
            ],
          },

          model: {
            org_id: current_org?.id,
            customer__name: record.customer__name,
            customer_id: record.customer_id,
            card__name: record.card__name,
            single_price: record.single_price,
            price: record.single_price,
            num: 1,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            shop_id: current_shop?.id,
            card_num:
              record.now_num == 0 && record.card_type == 11 && moment(record.end_date) > moment()
                ? 0
                : 1,
            card_record_id: record.id,
            _price: null, //显示使用
          },
          watch: {
            project_id: (data: any) => {
              if (data['project_id'] > 0) {
                get_project_by_id({
                  org_id: current_org.id,
                  project_id: Number(data.project_id),
                }).then((res: any) => {
                  data['_price'] = Math.trunc(res.price);
                  data['project_price'] = data['_price'] * data['num'];
                  data['diff_price'] = Number(data['project_price']) - Number(data['price']);
                });
              }
            },
            card_num: (data: any) => {
              if (data['card_num'] || data['card_num'] == 0) {
                data['price'] = Number(data['card_num']) * Number(data['single_price']);
                if (data['project_price']) {
                  data['diff_price'] = Number(data['project_price']) - Number(data['price']);
                }
              } else {
                data['diff_price'] = null;
              }
            },
            num: (data: any) => {
              data['project_price'] = Number(data['_price']) * Number(data['num']);
              data['diff_price'] = Number(data['project_price']) - Number(data['price']);
            },
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            create_order_used_record_by_card({
              org_id: payload.org_id,
              card_record_id: record.id,
              project_id: payload.project_id,
              diff_price: payload.diff_price,
              customer_id: payload.customer_id,
              staff_id: payload.staff_id,
              shop_id: payload.shop_id,
              card_num: payload.card_num,
              num: payload.num,
              date: payload.date,
              mark: payload.mark,
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '耗卡成功',
                });
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', record.customer_id);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '转卡',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.card_type == 31;
    },
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      let is_time_card = false;
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '转卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [5, 10],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'card__name',
              label: '原卡',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'number',
              name: 'card_use_num',
              label: '耗卡次数',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写耗卡次数',
            },
            {
              type: 'number',
              name: 'single_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目单价',
            },
            {
              type: 'number',
              name: '_old_card_sum_price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写项目金额',
            },
            {
              type: 'input',
              name: 'customer__name',
              label: '会员姓名',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'card_id',
              label: '新卡',
              disabled: false,
              placeholder: '请选择新卡',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-card',
            },
            {
              type: 'number',
              name: 'total_num',
              label: '项目次数',
              disabled: is_time_card,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'number',
              name: '_price',
              label: '项目单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'number',
              name: '_new_card_sum_price',
              label: '项目金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'number',
              name: '_diff_price',
              label: '直接返利',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-querystaffselectlist',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '购卡日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm',
              valueFormat: 'YYYY-MM-DD HH:mm',
              showTime: true,
              placeholder: '请选择购卡日期',
            },
            {
              type: 'textarea',
              name: 'mark',
              label: '备注',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 300,
              defaultValue: '',
              placeholder: '请填写备注',
            },
          ],
          rules: {
            card_id: [{ required: true, message: '请选新卡' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            card_use_num: [{ required: true, message: '请填写耗卡次数' }],
            total_num: [{ required: true, message: '请填写项目次数' }],
            date: [{ required: true, message: '请填写购卡时间' }],
          },
          model: {
            org_id: current_org?.id,
            card_use_num: 1,
            total_num: 1,
            shop_id: current_shop?.id,
            single_price: data.single_price,
            card__name: data.card__name,
            customer__name: data.customer__name,
            customer_id: data.customer_id,
            card_record_id: data.id,
            _price: null, //显示使用
            _new_card_price: null, //计算使用
            _new_card_sum_price: null,
            _diff_price: null,
            _old_card_sum_price: data.single_price,
            staff_id: null,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            mark: null,
          },
          watch: {
            card_id: (newData: any) => {
              if (newData['card_id'] > 0) {
                get_card_by_id({
                  org_id: current_org.id,
                  card_id: Number(newData.card_id),
                }).then((res: any) => {
                  newData['_price'] = res.price.toFixed(0);
                  newData['_new_card_price'] = res.price;
                  newData['_new_card_sum_price'] = (
                    Number(newData['total_num']) * Number(newData['_new_card_price'])
                  ).toFixed(0);
                  if (res['card_type'] === 11) {
                    newData['total_num'] = res['max_num'];
                    is_time_card = true;
                  } else {
                    is_time_card = false;
                  }
                  const f = editModal.form.fields.find((item: any) => {
                    return item.name == 'total_num';
                  });
                  if (f) {
                    f.disabled = is_time_card;
                  }
                  newData['_diff_price'] = (
                    Number(newData['_new_card_sum_price']) - Number(newData['_old_card_sum_price'])
                  ).toFixed(0);
                });
              }
            },
            card_use_num: (newData: any) => {
              newData['_old_card_sum_price'] =
                Number(newData['card_use_num']) * Number(newData['single_price']);
              newData['_diff_price'] = (
                Number(newData['_new_card_sum_price']) - Number(newData['_old_card_sum_price'])
              ).toFixed(0);
            },
            total_num: (newData: any) => {
              newData['_new_card_sum_price'] = (
                Number(newData['total_num']) * Number(newData['_new_card_price'])
              ).toFixed(0);
              newData['_diff_price'] = (
                Number(newData['_new_card_sum_price']) - Number(newData['_old_card_sum_price'])
              ).toFixed(0);
            },
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            trans_card_record({
              ...payload,
              org_id: current_org?.id,
            })
              .then(function () {
                message.success('转卡成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', data.customer_id);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '撤卡',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.used_status == 2 || record.card_type == 1;
    },
    cb: (record: any) => {
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const is_disabled = ref(false);
      if (record.card__project_type__p_type == 11) {
        is_disabled.value = true;
      }
      Modal.confirm({
        title: '撤卡仅用于客户退项目，若由于门店操作错误而需撤回订单，请点击作废。',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          const editModal = reactive({
            visible: true,
            loading: false,
            title: '撤卡',
            form: {
              settings: {
                labelAlign: 'right',
                layout: 'horizontal',
                col: [3, 4],
              },
              fields: [
                {
                  type: 'input',
                  name: 'customer__name',
                  label: '会员姓名',
                  disabled: true,
                },
                {
                  type: 'remoteselect',
                  name: 'card__name',
                  label: '卡',
                  disabled: true,
                  placeholder: '请选择卡',
                  datasourceType: 'remote',
                  mode: 'default',
                  allowClear: true,
                  modalType: 'mjstore-project',
                },
                {
                  type: 'input',
                  name: 'cancel_num',
                  label: '撤卡次数',
                  disabled: is_disabled,
                  allowClear: true,
                  inputType: 'number',
                  defaultValue: '',
                },
                {
                  type: 'remoteselect',
                  name: 'shop_id',
                  label: '执行门店',
                  disabled: !!current_shop,
                  placeholder: '请选择执行门店',
                  datasourceType: 'remote',
                  mode: 'default',
                  allowClear: true,
                  modalType: 'mjstore-shop',
                },
                {
                  type: 'remoteselect',
                  name: 'staff_id',
                  label: '执行人',
                  disabled: false,
                  placeholder: '请选择执行人',
                  datasourceType: 'remote',
                  mode: 'default',
                  allowClear: true,
                  modalType: 'mjstore-staff',
                },
                {
                  type: 'datepicker',
                  name: 'date',
                  label: '撤卡时间',
                  disabled: false,
                  allowClear: true,
                  defaultValue: '',
                  showTime: true,
                  format: 'YYYY-MM-DD HH:mm',
                  valueFormat: 'YYYY-MM-DD HH:mm',
                  placeholder: '请选择撤卡时间',
                },
                {
                  type: 'textarea',
                  name: 'reason',
                  label: '撤卡原因',
                  disabled: false,
                  allowClear: true,
                  inputType: 'text',
                  maxlength: 300,
                  defaultValue: '',
                  placeholder: '请填写撤卡原因',
                },
              ],
              rules: {
                staff_id: [{ required: true, message: '请选择执行人' }],
                shop_id: [{ required: true, message: '请选择执行门店' }],
                cancel_num: [{ required: true, message: '请填写撤卡次数' }],
                date: [
                  { required: true, message: '请选择撤卡时间' },
                  {
                    validator: async (rule: RuleObject, value: string) => {
                      if (moment(value) > moment()) {
                        return Promise.reject('不能选择大于当前日期的时间');
                      } else {
                        return Promise.resolve();
                      }
                    },
                    trigger: 'change',
                  },
                ],
                reason: [{ required: true, message: '请填写撤卡原因' }],
              },

              model: {
                org_id: current_org?.id,
                customer__name: record.customer__name,
                customer_id: record.customer_id,
                card__name: record.card__name,
                single_price: record.single_price,
                price: record.price,
                diff_price: 0,
                date: moment().format('YYYY-MM-DD HH:mm:ss'),
                cancel_num: record.now_num,
                shop_id: current_shop?.id,
                reason: null,
              },
              // watch: {
              //   project_id: (data: any) => {
              //     if (data['project_id'] > 0) {
              //       get_project_by_id({
              //         org_id: current_org.id,
              //         project_id: Number(data.project_id),
              //       }).then((res: any) => {
              //         data['project_price'] = res.price;
              //         data['diff_price'] = Number(data['project_price']) - Number(data['price']);
              //       });
              //     }
              //   },
              //   card_num: (data: any) => {
              //     data['price'] = Number(data['card_num']) * Number(data['single_price']);
              //     data['diff_price'] = Number(data['project_price']) - Number(data['price']);
              //   },
              // },
            },
            options: {},
            ok: (payload: any) => {
              return new Promise(resolve => {
                editModal.loading = true;
                delete_card_record({
                  ...payload,
                  org_id: current_org?.id,
                  card_record_id: record.id,
                })
                  .then(() => {
                    notification.success({
                      message: '成功',
                      description: '撤卡成功',
                    });
                    event_obj.emit('refresh');
                    event_bus.emit('refresh_custom_info', record.customer_id);
                    resolve(null);
                  })
                  .finally(() => {
                    editModal.loading = false;
                  });
              });
            },
          });
          modalBox(editModal);
        },
        onCancel() {},
      });
    },
  },
  // {
  //   name: '发送',
  //   clazz: 'primary',
  //   content: (record: any) => {
  //     return record.receipt_confirmed ? '已确认' : '发送';
  //   },
  //   disabled: (record: any) => {
  //     return !!record.receipt_confirmed;
  //   },
  //   cb: (record: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //     query_person_to_costom_list({
  //       org_id: current_org?.id,
  //       customer_id: record.customer_id,
  //     }).then((res: any) => {
  //       if (res.data.length == 0 || (res.data.length > 0 && !res.data[0].name)) {
  //         Modal.warning({
  //           title: '提示',
  //           content: '会员尚未绑定，无法发送',
  //         });
  //       } else {
  //         Modal.confirm({
  //           title: '提示',
  //           content: `即将发送购卡记录至客户公众号账号，是否继续发送（第${
  //             record.receipt_count + 1
  //           }次发送）`,
  //           onOk() {
  //             send_receipt({
  //               obj_id: record.id,
  //               business_type: 'CardRecord',
  //               org_id: current_org?.id,
  //             }).then(res => {
  //               message.success('发送成功');
  //               Object.assign(record, res);
  //             });
  //           },
  //           onCancel() {
  //           },
  //         });
  //       }
  //     });
  //   },
  // },

  {
    name: '作废',
    //type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return !record.is_delete && record.now_num === record.total_num && !record.set_record_id;
    },
    cb: (record: any) => {
      if (record.set_record_id) {
        Modal.confirm({
          title: '提示',
          content: `该项目所在套餐中的全部项目将同步作废，确定作废后请重新购买套餐`,
          onOk() {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            direct_delete_set_record({
              set_record_id: record.set_record_id,
              org_id: current_org?.id,
            }).then((res: any) => {
              if (res.show_message) {
                Modal.warning({
                  title: res.show_message,
                });
              } else {
                message.success('作废成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', record.customer_id);
              }
            });
          },
          onCancel() {},
        });
      } else {
        Modal.confirm({
          title: '提示',
          content: `是否作废此项记录`,
          onOk() {
            const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
            direct_delete_card_record({
              card_record_id: record.id,
              org_id: current_org?.id,
            }).then((res: any) => {
              if (res.show_message) {
                Modal.warning({
                  title: res.show_message,
                });
              } else {
                message.success('作废成功');
                event_obj.emit('refresh');
                event_bus.emit('refresh_custom_info', record.customer_id);
              }
            });
          },
          onCancel() {},
        });
      }
    },
  },
  {
    name: '延期',
    //type: 'dropdown',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.card_type == 11 && record.used_status == 2;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const modifyModal: any = reactive({
        visible: false,
        component: 'ExtendCardRecordModel',
        obj: {
          org_id: current_org?.id,
          ...record,
        },
      });
      modifyModal.visible = true;
      modifyModal.ok = () => {
        event_obj.emit('refresh');
      };
      modifyModal.cancel = () => {};
      modalBox(modifyModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [];
